import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { ActivityDto } from '@api/models/activity/ActivityDto';
import { activityService } from '@api/services/services';

type State = BaseType<ActivityDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsActivitySlice = baseSlice({
  name: 'optionsActivity',
  initialState,
});

export const selectOptionsActivityState = (state: RootState) => state.optionsActivity.state;
export const selectOptionsActivity = (state: RootState) => state.optionsActivity.data;
export const optionsActivityActions = optionsActivitySlice.actions;

export const getOptionsActivity = (cancelToken: CancelToken, oneTimeEntry?: boolean, search?: string) => (dispatch: AppDispatch) => {
  const handleGetData = async () => {
    const response = await activityService.query(
      {
        q: search,
        state: EntityState.Active,
        oneTimeEntry: oneTimeEntry,
        page: 0,
        size: AUTOCOMPLETE_MAX_ITEMS,
        sort: ['name', 'asc'],
      },
      { cancelToken: cancelToken as any }
    );
    return { data: response.data.content ?? [] };
  };

  getItem({
    dispatch,
    actions: optionsActivityActions,
    getData: handleGetData,
  });
};
